// A Seguimiento position as one form value: "<etapaId>:<subEtapaId>", or "<etapaId>:-" for
// an etapa without sub-etapas.

export const positionKey = (stageId, subStageId) =>
  `${stageId}:${subStageId === null || subStageId === undefined ? '-' : subStageId}`;

export const parsePosition = key => {
  const [stage, subStage] = String(key || '').split(':');
  return {
    currentStage: stage ? Number(stage) : null,
    currentSubStage: subStage && subStage !== '-' ? Number(subStage) : null
  };
};
